import { createAction, props } from '@ngrx/store';

import { ICarTrafficSummary } from '@ruby/shared/models/car-traffic/car-traffic.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

export const loadTrafficHistory = createAction(
  '[Car Traffic] Core Load Traffic History',
  props<{ data: string }>()
);

export const loadTrafficHistorySuccess = createAction(
  '[Car Traffic] Core Load Traffic History Success',
  props<{ data: Array<ICarTrafficSummary> }>()
);

export const loadTrafficHistoryFailure = createAction(
  '[Car Traffic] Core Load Traffic History Failure',
  props<{ error: IError }>()
);
